export default __webpack_public_path__ + "static/media/photo--lg--leena-1.59c54894.jpg";